import { render } from "./EditarSubmenu.vue?vue&type=template&id=03bee548"
import script from "./EditarSubmenu.vue?vue&type=script&lang=js"
export * from "./EditarSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__